import { useState } from 'react';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import DeviceGraph from '../../features/DeviceGraph/index.web';

const DeviceGraphWidget = ({ setShowCurrentDevice, selectedGroup, widget }) => {
  const {
    data: connectedDevices = [],
    isLoading: connectedDevicesLoading,
    isError: connectedDevicesError,
  } = useGetConnectedDevicesQuery();
  // Fixed at mount. The graph fetches a page of points whenever the range it is
  // given changes, so a `Date.now()` recomputed on every render of this widget
  // (every socket event re-renders it) would refetch on every render.
  const [initialRange] = useState(() => ({
    startTime: Date.now() - 24 * 60 * 60 * 1000,
    endTime: Date.now(),
  }));

  return (
    <div className="d-flex flex-column h-100 w-100 min-h-0 min-w-0 overflow-hidden">
      {connectedDevices?.length > 0 && (
        <DeviceGraph
          title={null}
          setShowCurrentDevice={setShowCurrentDevice}
          startTime={initialRange.startTime}
          endTime={initialRange.endTime}
          widget={widget}
          selectedGroup={selectedGroup}
        />
      )}
    </div>
  );
};

export default DeviceGraphWidget;
